import { openHelpCenter } from '@ubeya/shared/atoms/shared';
import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { buildIntercomBootPayload } from './utils';

// Module scope so the handler Intercom retains does not close over the component's props.
const NOOP = () => {};

// Module scope, not a ref: allDataLoaded flips false mid account switch and the component unmounts.
let hasBooted = false;

const Intercom = ({ data, account, billingStatus, accounts, branches, adminBranches, modules, privilegeIds }) => {
  const [isOpenHelpCenter, setIsOpenHelpCenter] = useRecoilState(openHelpCenter);

  useEffect(() => {
    // Every environment shares the production Intercom workspace, so only production may write to it.
    if (process.env.ENV !== 'PROD' || !window.Intercom) {
      return;
    }

    try {
      // Same admin across an account switch, only their attributes change: update, not a second boot.
      window.Intercom(
        hasBooted ? 'update' : 'boot',
        buildIntercomBootPayload({
          user: data,
          account,
          billingStatus,
          accounts,
          branches,
          adminBranches,
          modules,
          privilegeIds
        })
      );

      hasBooted = true;
    } catch {
      // Telemetry must never take the app down: Intercom renders outside the ErrorBoundary.
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isOpenHelpCenter) {
      window.Intercom?.('show');
      window.Intercom?.('onHide', () => {
        setIsOpenHelpCenter(false);
      });

      return () => window.Intercom?.('onHide', NOOP);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenHelpCenter]);

  return null;
};

export default React.memo(Intercom);
